import { Dispatch } from "redux";
import api from "../../api/api";
import {
    setaddbulkProfile, setloading, seterror, resetaddbulkProfile
} from "../reducers/addBulkProfileReducer";

const addBulkProfile = (data: any,token:any) => async (dispatch: Dispatch) => {
   dispatch(setloading(true));
   try {
     const result = await api
       .post(
        `school-admin/school/bulkupload/`,
        data,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Token ${token}`
          },
        }
       )
       
       if(result){
        dispatch(setloading(false));
        if (result.data?.status === 200) {
            dispatch(setaddbulkProfile(result.data));
          }
          else {
            dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
          }
       }
   }
   catch (error: any) {
    dispatch(seterror(error.response.data.message));
   }
}

export { addBulkProfile, resetaddbulkProfile } 

